"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScrollAreaScrollbarCssVars = void 0;
let ScrollAreaScrollbarCssVars = exports.ScrollAreaScrollbarCssVars = /*#__PURE__*/function (ScrollAreaScrollbarCssVars) {
  /**
   * The scroll area thumb's height.
   * @type {number}
   */
  ScrollAreaScrollbarCssVars["scrollAreaThumbHeight"] = "--scroll-area-thumb-height";
  /**
   * The scroll area thumb's width.
   * @type {number}
   */
  ScrollAreaScrollbarCssVars["scrollAreaThumbWidth"] = "--scroll-area-thumb-width";
  return ScrollAreaScrollbarCssVars;
}({});